import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Select } from '@mantine/core';
import AppCard from '../../common/AppCard';
import { useMediaQueryIndex } from '../../../helpers/hooks';
import AppFlexbox from '../../common/AppFlexbox';
import PrintDesignEditorTemplateSelector from './PrintDesignEditorTemplateSelector';

const ZOOM_OPTIONS = [
  { value: '0.25', label: '25%' },
  { value: '0.5', label: '50%' },
  { value: '0.75', label: '75%' },
  { value: '1', label: '100%' },
  { value: '1.25', label: '125%' },
  { value: '1.5', label: '150%' },
  { value: '2', label: '200%' }
];

const PrintDesignEditorFooter = ({
  ecomExternalProducts,
  formState,
  setFormState,
  canvasController
}) => {
  const { isTabletOrSmaller } = useMediaQueryIndex();
  const { zoomLevel, setZoom, zoomToFit } = canvasController;

  return (
    <AppFlexbox style={{ width: '100%', height: 80 }}>
      <AppCard
        shadow="md"
        style={{
          padding: 0,
          width: '100%',
          height: '100%'
        }}
        withBorder
      >
        <AppFlexbox
          style={{ height: '100%', gap: 0, flex: 1, alignItems: 'center' }}
        >
          <AppFlexbox
            style={{
              alignItems: 'center',
              gap: 5,
              color: '#000',
              padding: '10px 20px'
            }}
          >
            <Select
              data={[
                ...[
                  ...ZOOM_OPTIONS,
                  ...(zoomLevel !== 'zoomToFit' &&
                  !ZOOM_OPTIONS.find(
                    (opt) => opt.value === zoomLevel.toString()
                  )
                    ? [
                        {
                          value: zoomLevel.toString(),
                          label: `${(zoomLevel * 100).toFixed(0)}%`
                        }
                      ]
                    : [])
                ].sort((a, b) => parseFloat(a.value) - parseFloat(b.value)),
                { value: 'zoomToFit', label: 'Fit to Screen' }
              ]}
              onChange={(v) => {
                if (v) {
                  if (v === 'zoomToFit') {
                    zoomToFit();
                  }
                  else {
                    setZoom(v);
                  }
                }
              }}
              value={zoomLevel?.toString() || '1'}
            />
          </AppFlexbox>
          <Divider orientation="vertical" />

          <AppFlexbox
            style={{
              flex: 1,
              gap: 5,
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          />

          <AppFlexbox
            style={{
              height: '100%',
              padding: isTabletOrSmaller ? 10 : '10px 20px'
            }}
          >
            <PrintDesignEditorTemplateSelector
              ecomExternalProducts={ecomExternalProducts}
              formState={formState}
              setFormState={setFormState}
            />
          </AppFlexbox>
        </AppFlexbox>
      </AppCard>
    </AppFlexbox>
  );
};

PrintDesignEditorFooter.propTypes = {
  canvasController: PropTypes.object.isRequired,
  ecomExternalProducts: PropTypes.array.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired
};

export default PrintDesignEditorFooter;
